import { createApp } from 'vue';

import App from './App.vue';

// const language = "en"; // for development
// const mediaType = "press"; // for development: press, events
// const country = "AW"; // for development: all, AW, AWCH
// // const selectedProject = "all"; // for development: all, unding (to be completer)

const language = document.querySelector("#app").attributes["language"].value;
const mediaType = document.querySelector("#app").attributes["mediaType"].value;
const country = document.querySelector("#app").attributes["country"].value;
// const selectedProject = document.querySelector("#app").attributes["project"].value;

// const app = createApp(App, {mediaType, selectedProject, country});
const app = createApp(App, {mediaType, country});

app.config.globalProperties.$language = language;
app.mount('#app');





